export const ROLE_STUDENT = 'STUDENT';
export const ROLE_TEACHER = 'TEACHER';
export const ROLE_ADMINISTRATOR = 'SCHOOL_ADMINISTRATOR';
export const ROLE_SYSADMIN = 'SYSADMIN';
export const ROLE_MENTOR = 'MENTOR';
export const ROLE_COURSE_ADMIN = 'COURSE_ADMINISTRATOR';
export const ROLE_STANDARD_CURRICULUM_ADMIN = 'STANDARD_CURRICULUM_ADMIN';
export const ROLE_CONVERSATION_ADMIN = 'CONVERSATION_ADMIN';
export const ROLE_SPECIAL_PEDAGOGUE = 'SPECIAL_PEDAGOGUE';